import { AxiosError } from 'axios';

/**
 * Extrai a mensagem mais específica possível de um erro de API.
 * Formatos conhecidos:
 * - NestJS: { message: string | string[] }
 * - Hinova (repassado pelo backend): { mensagem: string, error: string[] | string }
 */
export const extrairMensagemErro = (error: unknown, fallback: string): string => {
  const data = (error as AxiosError<any>)?.response?.data;
  if (!data) return (error as Error)?.message || fallback;

  const paraTexto = (valor: unknown): string => {
    if (Array.isArray(valor)) return valor.filter(Boolean).join('; ');
    if (typeof valor === 'string') return valor;
    return '';
  };

  const detalhes = paraTexto(data.error);
  const base = paraTexto(data.message) || paraTexto(data.mensagem);

  if (base && detalhes) return `${base}: ${detalhes}`;
  return detalhes || base || fallback;
};
